﻿function gameviceInit() {
    
    if (typeof singleProduct !== 'undefined') {
        populatePlatformOptions();
        populateIosOptions();
    }
    
    $('#platform').change(function () {
        var platform = $(this).val();
        switch (platform) {
            case 'ios':
                populateIosOptions();
                break;
            case 'android':
                populateAndroidOptions();
                break;
        };
        updatePreOrderText();
    });

    $('#device').change(function () {
        updatePreOrderText();
    });

    function updatePreOrderText() {
        var platform = $('#platform').val();
        var deviceText = $('#device').find("option:selected").text();
        $("#GV160-Preorder").hide();
        $("#GV167-Preorder").hide();
        $("#GV169-Preorder").hide();
        $("#AddToCartSingleText").text('ADD TO CART');
        
        switch(platform) {
            case 'ios':
                switch (deviceText) {
                    case '10.5-inch iPad Pro':
                        $("#GV160-Preorder").show();
                        $("#AddToCartSingleText").text('PRE-ORDER');
                        break;
                }
                break;
            case 'android':
                switch (deviceText) {
                    case 'Samsung Galaxy S7/S7 edge':
                        $("#GV167-Preorder").show();
                        $("#AddToCartSingleText").text('PRE-ORDER');
                        break;
                    case 'Samsung Galaxy S8/S8+':
                        $("#GV169-Preorder").show();
                        $("#AddToCartSingleText").text('PRE-ORDER');
                        break;
                }
                break;
        };
    }

    $('#AddToCartForm-Single').submit(function(event) {
        var url = '';
        var variantId = '';
        var platform = $('#platform :selected').val();
        var productId = $('#device :selected').val();
        var products;
        switch (platform) {
            case 'ios':
                products = $.parseJSON(productsIos);
                break;
            case 'android':
                products = $.parseJSON(productsAndroid);
                break;
        }
        for (var i=0, len=products.length; i < len; i++) {
            if (products[i].id == productId) {
                variantId = products[i].variantId;
                break;
            }
        }

        $('#AddToCartForm-Single').attr('data-productid', productId);
        $('#single-productId').attr('data-productid', productId);
        $('#single-productId').attr('value', variantId);
        return;
    });

function populatePlatformOptions() {
    $('#platform').find('option').remove().end();
    $('#platform').append($('<option>', { value: 'ios', text: 'iOS' }));
    $('#platform').append($('<option>', { value: 'android', text: 'Android' }));
}

function populateIosOptions() {
    var products = $.parseJSON(productsIos);
    $('#device').find('option').remove().end();
    $.each(products, function(i, item) {
        $('#device').append($('<option>', { value: item.id, text: item.title }));
    });
}

function populateAndroidOptions() {
    var products = $.parseJSON(productsAndroid);
    $('#device').find('option').remove().end();
    $.each(products, function(i, item) {
        $('#device').append($('<option>', { value: item.id, text: item.title }));
    });
}

$(".video-carousel").owlCarousel({
    items: 3,
    loop: true,
    autoPlay: false,
    video: true
});
}


